angular.module('picmonic-common').factory('MarketOptionsConfig', [
  '$filter',
  'markets',
  function ($filter, markets) {
    return {
      markets: markets,
      getMarketById: function (id) {
        return $filter('findInArray')(this.markets, id, 'id');
      },
      getMarketBySlug: function (slug) {
        return $filter('findInArray')(this.markets, slug, 'slug');
      },
      getMarketByName: function (name) {
        return $filter('findInArray')(this.markets, name, 'name');
      },
    };
  },
]);
